/**
 * Ladezustand `kal-loading` — Skeleton **in Rasterform**, kein Spinner
 * (Spec 07 „Drei Zustände": vier Wochenzeilen mit je sieben leeren Zellen in
 * der Zielhöhe, dazu je zwei graue Balken). Dieselbe Höhe wie eine echte
 * `CalendarDayCell` (92px), damit beim Eintreffen der Antwort nichts springt
 * (`components/states/Skeleton.tsx`: „Ein Skeleton sagt: hier kommen sechs
 * Zeilen").
 *
 * Feste statt echter Zufallsspalten (dritte und fünfte Zelle je Zeile) — die
 * Spec sagt „zufällig", aber ein Skeleton, der bei jedem Rendern anders
 * aussieht, macht eine Aufnahme (`docs/work/…/screenshots/`) nicht
 * wiederholbar. Das Auge liest „verstreut", nicht „exakt zufällig".
 */

const WEEK_COUNT = 4
const DAY_COUNT = 7
const BAR_COLUMNS = new Set([2, 4])

export function CalendarSkeleton() {
  return (
    <div data-testid="kal-loading" aria-busy="true" aria-live="polite" className="flex flex-col gap-3 px-(--page-x) py-3">
      <span className="sr-only">Wird geladen</span>
      {Array.from({ length: WEEK_COUNT }, (_, weekIndex) => (
        <div key={weekIndex} className="grid grid-cols-7 gap-1.5">
          {Array.from({ length: DAY_COUNT }, (_, dayIndex) => (
            <div key={dayIndex} className="border-border rounded-card flex min-h-[92px] flex-col gap-1 border p-1.5">
              {BAR_COLUMNS.has(dayIndex) && (
                <>
                  <div className="bg-border h-2 w-full max-w-20 animate-pulse rounded-full" />
                  <div className="bg-border h-2 w-full max-w-16 animate-pulse rounded-full" />
                </>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
